import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {Dropdown, Spinner} from 'react-bootstrap'
import {UsersListPagination} from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import plusIcon from '../../../_metronic/images/smlplus.svg'
import arrow from '../../../_metronic/images/arr072.svg'
import {AGENT_ADMIN_LIST, GET_CIPHER_MESSAGE,GETCLIENTFEATUREFLAGS} from '../../../utils/GraphQLAPI'
import {CreateAgentModal} from './AgentModal/CreateAgentModal'
import './agent.scss';
import {useLazyQuery} from '@apollo/client'
import { alert, checkEmptyData, statusBadgeClassName } from '../../../utils/helper'
import momentTimezone from 'moment-timezone'

const CustomerList = ({getSalesAdminDashboardData}:any) => {

    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
    const [createModal] = useState<string>('create')
    const [customerId, setCustomerId] = useState<any>()
    const [modalConfig,setModalConfig]=useState<any>({})

    const openModal = (event: any, mode:any,editId="") => {
      setModalConfig({
        mode,
        editId
      })
      setShowCreateAppModal(true)
    }
  
    const handleCloseModal = () => {
      setShowCreateAppModal(false)
      setCustomerId('');
    }
    const [page, updatePage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)
    const [customers, setCustomers] = useState<any>()
    const [total, setTotal] = useState<any>()
    const [customerStatus, setCustomerStatus] = useState<any>(null)
  
    useEffect(() => {
      getCustomersByAdmin()
      getClientFeatureflags()
    }, [])
  
    const refreshCustomerList = () => {
      refetch()
    }
  
    const getCustomersbyTpvStatus = (detail:any) =>{
      detail === 'All' ? setCustomerStatus(null):
      setCustomerStatus(detail);
      getCustomersByAdmin();
    }
  
    const [getCustomersByAdmin,  {loading, refetch}] = useLazyQuery(AGENT_ADMIN_LIST, {
      fetchPolicy:'network-only',
      variables:{
        customerListInput:{
          page:  page + 1 ,
          perPage: rowsPerPage,
          tpvStatus:customerStatus?.toUpperCase(),
          timeZone: momentTimezone.tz.guess(),
        }
      },
      onCompleted: (data1) => {
        setCustomers(data1.getAllCustomersByAgent.customers)
        setTotal(data1.getAllCustomersByAgent.totalCount)
      }
    })
    const [getClientFeatureflags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
      fetchPolicy: 'network-only',
    })
    const [getCipherMessage]=useLazyQuery(GET_CIPHER_MESSAGE,{
      onCompleted:(data)=>alert(data.getCipherMessage,"success"),
      fetchPolicy:"network-only"
    })
  
  return (
    <>
     <div className='row g-5 gx-xxl-8'>
        <div className=''>
          <KTCard>
            <div className='card-header border-0 rounded-0 pt-5'>
              <div className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1 cardHeaderStyle'>Enrollment List</span>
                <span className='text-muted mt-1 cardSpanStyle'>
                  <strong className='text-dark'>{total}</strong> Enrollments
                </span>
              </div>
              <div className='d-flex flex-column flex-md-row justify-content-between w-139px align-items-center mt-5'>

                <div className='h-43px border-0 rounded ms-4'>
                  <a
                    className='btn btn-lignt btn-sm  bg-secondary d-flex align-items-center justify-content-between w-170px'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    style={{
                      borderRadius: '6px',
                      background: '#F4F4F4',
                      height: '43px',
                      width: '135px',
                      color: '#7E8299'
                    }}
                  >
                     {customerStatus ? customerStatus : 'Status'}
                    <img src={arrow} alt='' width='22px' height='22px' />
                  </a>

                  {/* begin::Menu */}
                  <div
                    className='menu menu-sub menu-sub-dropdown menu-column menu-gray-600 menu-state-bg-primary w-auto fs-7 py-4 w-170px'
                    data-kt-menu='true'
                    style={{
                      borderRadius: '6px',
                      width: '135px',
                      maxHeight: '200px',
                      overflowY: 'scroll',
                    }}
                  >
                     <div className='menu-item'>
                      <a className='menu-link px-3' onClick={()=>{getCustomersbyTpvStatus('All')}}>All</a>
                    </div>
                    <div className='menu-item'>
                      <a className='menu-link px-3' onClick={()=>{getCustomersbyTpvStatus('Failed')}}>Failed</a>
                    </div>
                    <div className='menu-item'>
                      <a className='menu-link px-3' onClick={()=>{getCustomersbyTpvStatus('Incomplete')}}>Incomplete</a>
                    </div>
                    <div className='menu-item'>
                      <a className='menu-link px-3' onClick={()=>{getCustomersbyTpvStatus('Pending')}}>Pending</a>
                    </div>
                   
                  </div>
                </div>
                <div className='card-toolbar ms-4'>
                  
                  <button
                    className='btn btn-primary'
                    onClick={(e) => openModal(e,'create')}
                  >
                    <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                    <span>Enroll New Customer</span>
                  </button>
                </div>
                {
                  <CreateAgentModal
                    show={showCreateAppModal}
                    handleClose={handleCloseModal}
                    refetchList={getCustomersByAdmin}
                    method={createModal}
                    editId={customerId}
                    modalConfig={modalConfig}
                    getSalesAdminDashboardData={getSalesAdminDashboardData}
                    featureFlags={featureFlags}
                  />
                }
              </div>
            </div>
            <KTCardBody className='px-9 py-0 min-h-400px mt-4'>
            {total !== 0? (   
            <div className='table-responsive-xxl'>
               {loading ? (
                  <div className='text-center'>
                    <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                  </div>
                ) : (
              <table
               className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'
              >
                <thead className="mt-4">
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200 mt-4'>
                    <th className='header_title'>First Name</th>
                    <th className='header_title'>Last Name</th>
                    <th className='header_title'>Phone Number</th>
                    <th className='header_title'>Type</th>
                    <th className='header_title'>E_UAN</th>
                    <th className='header_title'>G_UAN</th>
                    <th className='header_title'>City</th>
                    <th className='header_title'>State</th>
                    <th className='header_title'>Utility</th>
                    <th className='header_title'>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {customers &&
                    customers.map((eachCustomer: any) => {  
                      return (
                        
                        <tr
                          className='tableBodyRowStyle'
                          key={eachCustomer.id}

                        >
                          <td className='name'>{eachCustomer.firstName}</td>
                          <td className='name'>{eachCustomer.lastName}</td>
                          <td className='content'>  {Boolean(eachCustomer.phoneNumber) ? '+1' : ''}{' '}
                            {`${eachCustomer.phoneNumber.slice(0, 3)} ${eachCustomer.phoneNumber.slice(3,6)} 
                            ${eachCustomer.phoneNumber.slice(6, 10)}`}
                         </td>
                         <td className='content'>{ eachCustomer.tpvType==="SMS TPV"?"Text TPV":checkEmptyData(eachCustomer.tpvType)}</td>
                          <td className='content'>
                            {checkEmptyData(eachCustomer.eutilityAccountNumber)}
                          </td>
                          <td className='content'>
                          {checkEmptyData(eachCustomer.gutilityAccountNumber)}
                          </td>
                          <td className='content'>{eachCustomer.serviceCity}</td>
                          <td className='content'>{eachCustomer.serviceState}</td>
                          <td className='content'>{eachCustomer.utilityName}</td>
                          <td className='content'><span className={`${statusBadgeClassName(eachCustomer?.tpvStatus)}`}>
                                {eachCustomer?.tpvStatus}
                              </span></td>
                              <td className='content'>
                                <Dropdown className='show-override'>
                                  <Dropdown.Toggle
                                    id='dropdown-custom-1'
                                    className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                    style={{background: 'none!important'}}
                                  >
                                    <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                                  <Dropdown.Item as='div' onClick={(e) => openModal(e,"edit" ,eachCustomer.customerId)} className='text-gray-600 fs-7 menu-item p-0'>
                                      <div className='menu-link'>Edit</div>
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                           
                              </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table> 
               )}
               </div>):(<div className="fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center mt-5">No Results Found</div>) }
            </KTCardBody>
            {total !== 0 ? (
            <div className="card-footer border-0">
            <UsersListPagination
                page={page}
                total={total}
                updatePage={updatePage}
                recordsPerPage={(e: any) => {
                  setRowsPerPage(parseInt(e))
                }}
                rowsPerPage={rowsPerPage}
              />
            </div>
             ):(
              <></>
            )}
          </KTCard>
        </div>
      </div>
      
    </>
  )
}

export default CustomerList
